module.exports = __webpack_public_path__ + "static/media/flowchart.cdee3d6e.webp";